import React from "react";
import { ASSETS } from "../lib/api";

const White = () => (
  <div data-testid="white-page">
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 lg:pt-20 pb-14">
      <div className="text-[10px] tracking-[0.4em] uppercase text-gold mb-6">Coming Soon</div>
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-ink max-w-4xl">
        The <em className="text-gold not-italic italic">White</em> Wedding
      </h1>
      <p className="mt-6 text-base sm:text-lg text-ink-soft max-w-xl">
        A second celebration is on the horizon.
      </p>
    </section>

    <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-16">
      <div className="flex justify-center">
        <div className="video-frame w-full max-w-[360px] sm:max-w-[400px]">
          <video
            data-testid="white-video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            poster={ASSETS.coupleEmbrace}
            className="w-full aspect-[9/16] object-cover bg-ink"
          >
            <source src={ASSETS.videoWhite} type="video/mp4" />
            Your browser does not support this video. <a href={ASSETS.videoWhite} className="text-gold underline">Download the save-the-date</a>.
          </video>
        </div>
      </div>
      <div className="text-center text-[10px] tracking-[0.3em] uppercase text-gold mt-6">Save-the-Date Teaser</div>
    </section>

    <section className="bg-cream/60 border-y border-hairline">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 text-center">
        <div className="hairline mb-10 justify-center"><span>A · M</span></div>
        <h2 className="font-serif text-4xl sm:text-5xl text-ink leading-tight tracking-tight">
          White Wedding details, coming soon.
        </h2>
        <div className="mt-8 space-y-5 text-ink-soft leading-[1.9] text-base sm:text-lg max-w-2xl mx-auto">
          <p>We are so excited to celebrate this next chapter with you.</p>
          <p>
            Details for <span className="font-serif italic text-ink">Anjola &amp; Michael&rsquo;s</span> White Wedding will
            be shared here soon. Please check back for updates.
          </p>
        </div>

        <p className="pt-10">
          <span
            data-testid="white-rsvp-status"
            className="inline-block border border-hairline px-6 py-3 text-[11px] tracking-[0.3em] uppercase text-ink-faint bg-ivory"
          >
            White Wedding RSVP is not open yet
          </span>
        </p>
      </div>
    </section>

    <section className="max-w-5xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-2 gap-10 items-center">
      <img src={ASSETS.coupleEmbrace} alt="Anjola and Michael" loading="lazy" className="w-full aspect-[3/4] object-cover" />
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-gold mb-4">Until then</div>
        <div className="font-serif text-3xl sm:text-4xl text-ink leading-tight tracking-tight">
          Every love story deserves a beautiful chapter — and ours is only just beginning.
        </div>
        <p className="mt-6 text-ink-soft leading-relaxed">
          Keep an eye on this page for the White Wedding date, venue, dress code, and RSVP details.
        </p>
      </div>
    </section>
  </div>
);

export default White;
